import easytransferImg from "../../../assets/images/easytransfer.svg";
import flywireImg from "../../../assets/images/flywire.svg";

import easytransferLightImg from "../../../assets/images/easytransfer_light.svg";
import flywireLightImg from "../../../assets/images/flywire_light.svg";
import transferMateLightImg from "../../../assets/images/transfermate_light.png";
import transferMateDarkImg from "../../../assets/images/transfermate_dark.png";
import bankIcon from "../../../assets/images/barclays.png";
import payrImg from "../../../assets/images/payr.png";


export const paymentMethods = [
  {
    name: "bank_transfer",
    img: bankIcon,
    imgLight: bankIcon,
  },
  {
    name: "transfermate",
    img: transferMateLightImg,
    imgLight: transferMateDarkImg,
  },
  {
    name: "easytransfer",
    img: easytransferImg,
    imgLight: easytransferLightImg,
  },
  // flywire hidden
  {
    name: "flywire",
    img: flywireImg,
    imgLight: flywireLightImg,
  },
  {
    name: "payr",
    img: payrImg,
    imgLight: payrImg,
  },
];
